function sampleValueForType(type) {
  switch (String(type).toLowerCase()) {
    case "int":
    case "integer":
      return 0;

    case "float":
    case "double":
    case "number":
      return 0.0;

    case "boolean":
      return false;

    case "string":
      return "example";

    default:
      return null;
  }
}

export function generateMqttxCommand({
  broker,
  port,
  deviceId,
  authToken,
  username,
  topic,
  schema = [],
  securityMode = "PLAINTEXT",
  caCertFilename,
  clientCertFilename,
  clientKeyFilename,
  metrics = [],
}) {
  const data = {};
  const source = [];
  const seen = new Set();

  [...(Array.isArray(schema) ? schema : []), ...(Array.isArray(metrics) ? metrics : [])].forEach((field) => {
    const key = field?.key || field?.metric_key || field?.normalized_key;
    if (!key || seen.has(key)) return;
    seen.add(key);
    source.push(field);
  });

  source.forEach((field) => {
    const key = field?.key || field?.metric_key || field?.normalized_key;
    if (!key) return;
    data[key] = sampleValueForType(field?.type || field?.inferred_type);
  });

  const payload = {
    timestamp: new Date().toISOString(),
    type: "telemetry",
    ...(authToken ? { device_token: authToken } : {}),
    data,
  };

  if (String(securityMode).toUpperCase() === "TLS") {
    return `mqttx pub \\
  -h ${broker} \\
  -p ${port} \\
  --cafile ./${caCertFilename || "ca.crt"} \\
  --cert ./${clientCertFilename || "device.crt"} \\
  --key ./${clientKeyFilename || "device.key"} \\
  -t ${topic} \\
  -q 0 \\
  -m '${JSON.stringify(payload, null, 2)}'`;
  }

  return `mqttx pub \\
  -h ${broker} \\
  -p ${port} \\
  -u ${username || deviceId} \\
  -P ${authToken} \\
  -t ${topic} \\
  -q 0 \\
  -m '${JSON.stringify(payload, null, 2)}'`;
}
